document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("label.file-drop-zone").forEach((label) => {
    const inputId = label.getAttribute("for");
    const input = document.getElementById(inputId);
    if (!input) return;

    label.addEventListener("drop", (e) => {
      e.preventDefault();
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(files[0]);
        input.files = dataTransfer.files;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });
});
